/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ event: NonNullable<unknown> }} Oauth_For_EventInputs */



/**
* | output |
* | --- |
* | "for the event {event}" |
*
* @param {Oauth_For_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const oauth_for_event = /** @type {((inputs: Oauth_For_EventInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Oauth_For_EventInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`pour l'événement ${i?.event}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`para el evento ${i?.event}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`para o evento ${i?.event}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`per l'evento ${i?.event}`)
	return /** @type {LocalizedString} */ (`for the event ${i?.event}`)
});